// The image types the backend presigns, by the extensions they are picked with.
export const IMAGE_CONTENT_TYPES = {
  'image/png': ['.png'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/svg+xml': ['.svg'],
};

type ImageContentType = keyof typeof IMAGE_CONTENT_TYPES;

// Own keys only, so `constructor` and friends are not types.
const isImageContentType = (type: string): type is ImageContentType =>
  Object.hasOwn(IMAGE_CONTENT_TYPES, type);

// A presigned PUT is signed with one exact content type, so normalise what the browser reports
// (it can be empty or `image/jpg`) to the canonical type, falling back to the extension.
export const getImageContentType = (file: File): ImageContentType | null => {
  if (isImageContentType(file.type)) return file.type;
  const extension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
  const match = Object.keys(IMAGE_CONTENT_TYPES)
    .filter(isImageContentType)
    .find((type) => IMAGE_CONTENT_TYPES[type].includes(extension));
  return match ?? null;
};
